import { render } from "./CollapsibleTR.vue?vue&type=template&id=0eb7a21d&scoped=true"
import script from "./CollapsibleTR.vue?vue&type=script&lang=js"
export * from "./CollapsibleTR.vue?vue&type=script&lang=js"

import "./CollapsibleTR.vue?vue&type=style&index=0&id=0eb7a21d&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb7a21d"]])

export default __exports__